export const GET_LIST_OF_360_VEHICLES = "GET_LIST_OF_360_VEHICLES";
export const VEHICLES_360_FETCH_ERROR = "VEHICLES_360_FETCH_ERROR";
